import { makeVar } from "@apollo/client";

export const userId = makeVar<string>("initial");
